import { render, staticRenderFns } from "./StackedHorizontalChart.vue?vue&type=template&id=49f7458b"
import script from "./StackedHorizontalChart.vue?vue&type=script&lang=js"
export * from "./StackedHorizontalChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports